import React from 'react';
import { Link } from '@reach/router';

import './style.scss';

const Beach = ({ link, beach, description, image }) => (
  <Link to={link}>
    <div className="square beach shadowed">
      <div className={`content ${beach.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()}-border`}>
        <div className={`dot shadowed ${beach.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()}-bg`} />
        <h2>{beach}</h2>
        <p className="description">{description}</p>
      </div>
      <div className="background" style={{ backgroundImage: `url(${image})` }}>
        <div className={`hover-overlay ${beach.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-').toLowerCase()}-bg`} />
      </div>
    </div>
  </Link>
);

export default Beach;
